import React from 'react'
import {useSelector} from 'react-redux'
import {RootState} from '../../store/rootState'

export default function MqMedium (props) {
  const size = useSelector((state: RootState) => state.mq.size)
  return size === 'm' ? props.children : null
}
